export const getCookie = (name: string) => {
  const cookieName = `${document.cookie};`.match(new RegExp(`${name}=.*;`));
  return cookieName && cookieName[0].split(/=|;/)[1];
};

export const setCookie = (
  name: string,
  value: string | null,
  days?: number,
) => {
  const e = new Date();
  e.setDate(e.getDate() + (days || 365));

  document.cookie = `${name}=${value};expires=${e.toUTCString()};path=/;domain=.${
    document.location.host
  }`;
};

export const deleteCookie = (name: string) => {
  setCookie(name, null, -1);
};
